import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=0d2f83a8&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=0d2f83a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f83a8",
  null
  
)

export default component.exports